const { getElement, getElements } = window.BAO.Utils

class MahinaOptions extends window.BAO.CustomElement() {
  static methods = ['setOptionHeights', 'toggleOption', 'onColourChoice']
  static targets = ['option']

  setupListeners () {
    super.setupListeners()

    this.els.option?.elements.forEach((option) => {
      this.listeners.add(option, 'click', this.toggleOption)
    })

    getElements('[data-product-colour]', { context: this.el }).forEach(
      (colourEl) => {
        this.listeners.add(colourEl, 'click', this.onColourChoice)
      },
    )

    window.addEventListener('load', this.setOptionHeights.bind(this))
    window.addEventListener('resize', this.setOptionHeights.bind(this))
  }

  setOptionHeights () {
    this.els.option?.elements.forEach((option) => {
      const content = getElement('.mhn-Option_Content', { context: option })
      content.classList.add('mhn-Option_Content-noTransition')
      content.style.setProperty('--MaxHeight', `none`)

      const height = content.clientHeight

      content.style.setProperty('--MaxHeight', `${height}px`)
      content.classList.remove('mhn-Option_Content-noTransition')
    })
  }

  toggleOption (event) {
    if (
      !window.BAO.MediaBreakpoints.isXsViewport ||
      event.target.closest('.mhn-Option_ViewDetails') ||
      event.target.closest('.mhn-Option_Button') ||
      event.target.closest('.mhn-Option_Colour')
    ) {
      return true
    }

    event.preventDefault()

    const currentOption = event.target.closest('.mhn-Club_Item')
    const currentOptionIsClosed =
      currentOption.getAttribute('aria-expanded') === 'false'
    currentOption.setAttribute('aria-expanded', currentOptionIsClosed)
  }

  onColourChoice (event) {
    event.preventDefault()

    const selectedColourEl = event.target.closest('[data-product-colour]')
    const card = selectedColourEl.closest('.mhn-Option')
    const colourEls = getElements('[data-product-colour]', { context: card })
    const select = getElement('.js-Product_Select', { context: card })
    const quickAddTriggers = getElements('[data-mahina-quick-add-trigger]', {
      context: card,
    })

    const variant = selectedColourEl.dataset.variant
    if (select) {
      select.value = variant
    }

    colourEls.forEach((el) => {
      el.setAttribute('aria-current', variant === el.dataset.variant)
    })

    quickAddTriggers.forEach((quickAddTrigger) => {
      quickAddTrigger.dataset.variant = variant
    })
  }
}

if (!customElements.get('mahina-options')) {
  customElements.define('mahina-options', MahinaOptions)
}
